<main>
  <article class="w-100 h-100 absolute top-0 left-0 grid">
    <div class="my-auto w-100 h-min">
      <header class="relative text-center mx-auto mb-4">
        <h1 class="title-login fw-semibold mb-3">
          Bienvenido a tu <br class="d-none d-md-block"> oficina virtual
        </h1>
        <h5 class="subtitle-login fw-semibold">
          Gestiona las solicitudes de crédito <br class="d-md-none"> de tus clientes
        </h5>
      </header>
      <div class="item p-4 my-auto">
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="mt-0">
          <h4 class="fw-semibold text-white">Iniciar sesión</h4>
          <div class="form-field mt-4">
            <label htmlFor="user" for="user" class="form-label">Usuario</label>
            <input type="text" class="form-control" placeholder="*número de cédula" id="user" formControlName="user"
              autocomplete="off">
            <div *ngIf="loginForm.controls.user.hasError('pattern')" class=" form-error">
              Este campo solo acepta <strong>números</strong>
            </div>
            <div *ngIf="loginForm.controls.user.hasError('minlength')" class="form-error">
              Minimo 8 caracteres
            </div>
            <div *ngIf="loginForm.controls.user.hasError('required') && !loginForm.controls.user.pristine"
              class="form-error">
              El usuario es requerido
            </div>
          </div>
          <div class="form-field">
            <label htmlFor="password" for="password" class="form-label">Contraseña</label>
            <div class="action-button">
              <input [type]="hide ? 'password': 'text'" class="form-control background-icon"
                [ngClass]="hide ? 'form-password-show' : 'form-password-hide'" placeholder="*contraseña" id="password"
                formControlName="password" autocomplete="off">
              <span (click)="hide=!hide"></span>
            </div>
            <div *ngIf="loginForm.controls.password.hasError('pattern')" class=" form-error">
              La contraseña no coincide con el patrón
            </div>
            <div *ngIf="loginForm.controls.password.hasError('minlength')" class="form-error">
              Minimo 8 caracteres
            </div>
            <div *ngIf="loginForm.controls.password.hasError('maxlength')" class="form-error">
              Maximo 33 caracteres
            </div>
            <div *ngIf="loginForm.controls.password.hasError('required') && !loginForm.controls.password.pristine"
              class="form-error">
              La contraseña es requerida
            </div>
            <div class="form-error" *ngIf="errorLog">
              {{ errorLog }}
            </div>
          </div>
          <div class="px-4">
            <button-look-feel [type]="'submit'" [block]="true" color="secondary"
              [disabled]="!this.loginForm.valid">Iniciar sesión</button-look-feel>
          </div>
        </form>
        <footer class="d-flex justify-content-center my-4">
          <app-hyperlink-icon routerLink="/recuperar-contrasena">¿Olvidaste tu contraseña?</app-hyperlink-icon>
        </footer>
      </div>
    </div>
  </article>
</main>